interface options {
	label: string;
	value: string;
	extraText?: string;
}
interface RadioButtonProps {
	options: options[],
	selectedOption: string,
	// onOptionChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
	onOptionChange: (value: string) => void;
}

function RadioButton({ options, selectedOption, onOptionChange }: RadioButtonProps) {
	return (
		<div>
			{options.map(option => (
				<div key={option.value} className="mb-2.5">
					<input
						value={option.value}
						checked={selectedOption === option.value}
						// onChange={onOptionChange}
						onChange={() => onOptionChange(option.value)}
						className="custom-radio"
						type="radio"
						id={option.value}
						name="radio-group" />

					<label className="text-sm text-[#344054] font-interMedium" htmlFor={option.value}>{option.label}</label>
					<p className="text-sm text-[#475467] pl-7">{option.extraText}</p>
				</div>
			))}
		</div>
	);
}

export default RadioButton;
